import GlobalStatusesContext from 'contexts/global-statuses';
import { ReactNode, useCallback, useMemo, useState } from 'react';

const GlobalStatusesProvider = ({ children }: { children: ReactNode }) => {
  const [globalStatuses, setGlobalStatuses] = useState<string[]>([]);

  const addGlobalStatus = useCallback((status: string) => {
    setGlobalStatuses(statuses => [
      ...statuses.filter(s => s !== status),
      status,
    ]);
  }, []);

  const removeGlobalStatus = useCallback(
    (status: string) =>
      setGlobalStatuses(statuses => statuses.filter(s => s !== status)),
    []
  );

  const value = useMemo(
    () => ({ globalStatuses, addGlobalStatus, removeGlobalStatus }),
    [addGlobalStatus, globalStatuses, removeGlobalStatus]
  );

  return (
    <GlobalStatusesContext.Provider value={value}>
      {children}
    </GlobalStatusesContext.Provider>
  );
};

export default GlobalStatusesProvider;
